/* ============================================================
   批量价档位表行为脚本（增强版）
   - 三级优先级：variant_overrides > 产品 Metafields > 全局默认
   - 主价格区实时联动（product-pricing 中的价格会跟着数量变）
   - 点击阶梯行自动填充数量
   - 预估总价实时展示
   - 变体切换时刷新基础价与阶梯
   ============================================================ */
   (function () {
    'use strict';
  
    var cfg = window.QTY_BREAKS;
    if (!cfg) return;
    var moneyFormat = cfg.moneyFormat || '${{amount}}';
  
    function toCents(p) {
      if (p == null) return 0;
      if (typeof p === 'number') return p;
      var s = String(p).trim();
      if (s.indexOf('.') !== -1) return Math.round(parseFloat(s) * 100);
      return parseInt(s, 10) || 0;
    }
  
    function formatMoney(cents, format) {
      cents = Math.round(typeof cents === 'string'
        ? parseInt(String(cents).replace(/\D/g, ''), 10)
        : cents);
      if (isNaN(cents)) cents = 0;
      format = format || moneyFormat;
      var regex = /\{\{\s*(\w+)(.*?)\s*\}\}/;
      var m = format.match(regex);
      if (!m) return (cents / 100).toFixed(2);
      var key = m[1];
      var num;
      if (key === 'amount_no_decimals' || key === 'amount_no_decimals_with_comma_separator') {
        num = (cents / 100).toLocaleString(undefined, { maximumFractionDigits: 0 });
      } else if (key === 'amount_with_comma_separator') {
        num = (cents / 100)
          .toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
          .replace(/\./g, 'X').replace(/,/g, '.').replace(/X/g, ',');
      } else if (key === 'amount_with_space_separator' || key === 'amount_with_period_and_space_separator') {
        num = (cents / 100)
          .toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
          .replace(/,/g, ' ');
      } else {
        num = (cents / 100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      }
      return format.replace(regex, num);
    }
  
    function resolveTiers(container) {
      var productTiersRaw = container.dataset.productTiers;
      var variantId = container.dataset.variantId;
      if (productTiersRaw && variantId) {
        try {
          var pt = JSON.parse(productTiersRaw);
          if (pt && pt.variant_overrides) {
            var key = 'gid://shopify/ProductVariant/' + variantId;
            var vo = pt.variant_overrides[key] || pt.variant_overrides[variantId];
            if (vo && vo.tiers && vo.tiers.length) return vo.tiers;
          }
        } catch (e) { /* fall through */ }
      }
  
      if (productTiersRaw) {
        try {
          var pt2 = JSON.parse(productTiersRaw);
          if (pt2 && pt2.tiers && pt2.tiers.length) return pt2.tiers;
        } catch (e) { /* fall through */ }
      }
  
      return (cfg.defaultTiers && cfg.defaultTiers.length) ? cfg.defaultTiers : [];
    }
  
    function buildList(container) {
      var base = parseInt(container.dataset.basePrice, 10) || 0;
      var list = container.querySelector('[data-qty-breaks-list]');
      if (!list) return;
  
      var tiers = resolveTiers(container);
      if (!tiers.length) return;
  
      var html = '';
      for (var i = 0; i < tiers.length; i++) {
        var t = tiers[i];
        var discount = parseFloat(t.discount) || 0;
        var price = Math.round(base * (1 - discount));
        var strike = discount > 0
          ? '<s class="qty-breaks__orig">' + formatMoney(base, moneyFormat) + '</s>'
          : '';
        var label = t.label || (t.min + (t.max ? '–' + t.max : '+') + ' pcs');
        var badge = discount > 0
          ? '<span class="qty-breaks__discount-badge">Save ' + Math.round(discount * 100) + '%</span>'
          : '';
  
        html +=
          '<li class="qty-breaks__item"' +
          ' data-qb-min="' + t.min + '"' +
          ' data-qb-max="' + (t.max === null ? '' : t.max) + '"' +
          ' data-qb-discount="' + discount + '"' +
          ' data-qb-price="' + price + '"' +
          ' role="button" tabindex="0"' +
          ' aria-label="' + label + ' — From ' + formatMoney(price, moneyFormat) + '/pc">' +
            '<span class="qty-breaks__range">' + label + '</span>' +
            '<span class="qty-breaks__price">' + badge + strike + '<span class="qty-breaks__from">From</span> ' + formatMoney(price, moneyFormat) + '</span>' +
          '</li>';
      }
      list.innerHTML = html;
    }
  
    function update(container) {
      var base = parseInt(container.dataset.basePrice, 10) || 0;
      var form = container.closest('form');
      var input = form ? form.querySelector('[data-quantity-input]') : null;
      var qty = input ? (parseInt(input.value, 10) || 1) : 1;
      if (qty < 1) qty = 1;
  
      var items = container.querySelectorAll('.qty-breaks__item');
      var active = null;
      items.forEach(function (it) {
        var min = parseInt(it.dataset.qbMin, 10);
        var max = it.dataset.qbMax === '' ? Infinity : parseInt(it.dataset.qbMax, 10);
        var on = qty >= min && qty <= max;
        it.classList.toggle('is-active', on);
        if (on) active = it;
      });
      if (!active && items.length) {
        active = items[items.length - 1];
        active.classList.add('is-active');
      }
      if (!active) return;
  
      var discount = parseFloat(active.dataset.qbDiscount) || 0;
      var price = parseInt(active.dataset.qbPrice, 10) || Math.round(base * (1 - discount));
      var total = Math.round(price * qty);
  
      // 更新「你的单价」
      var you = container.querySelector('[data-qty-breaks-you]');
      if (you) {
        you.querySelector('[data-qb-qty]').textContent = qty;
        you.querySelector('[data-qb-you-price]').innerHTML = formatMoney(price, moneyFormat) + '/pc';
        var saveEl = you.querySelector('[data-qb-you-save]');
        saveEl.textContent = discount > 0 ? ('Save ' + Math.round(discount * 100) + '%') : '';
        you.hidden = false;
      }
  
      // 更新「预估总价」
      var totalEl = container.querySelector('[data-qty-breaks-total]');
      if (totalEl) {
        totalEl.querySelector('[data-qb-total-price]').innerHTML = formatMoney(total, moneyFormat);
        var totalSaveEl = totalEl.querySelector('[data-qb-total-save]');
        if (discount > 0) {
          var saved = Math.round(base * qty * discount);
          totalSaveEl.innerHTML = '(You save ' + formatMoney(saved, moneyFormat) + ')';
          totalSaveEl.hidden = false;
        } else {
          totalSaveEl.hidden = true;
        }
        totalEl.hidden = false;
      }
  
      updateMainPrice(container, price, base, discount, qty);
    }
  
    function updateMainPrice(container, tierPrice, basePrice, discount, qty) {
      var pricingEl = document.querySelector('[data-product-pricing]');
      if (!pricingEl) return;
  
      var priceEl = pricingEl.querySelector('[data-price]');
      var compareEl = pricingEl.querySelector('[data-price-compare]');
      var compareContainer = pricingEl.querySelector('[data-price-compare-container]');
  
      if (priceEl) {
        priceEl.innerHTML = formatMoney(tierPrice, moneyFormat);
      }
  
      if (compareContainer) {
        if (discount > 0) {
          compareContainer.classList.add('visible');
          if (compareEl) {
            compareEl.innerHTML = formatMoney(basePrice, moneyFormat);
          }
        } else {
          compareContainer.classList.remove('visible');
        }
      }
    }
  
    function initContainer(container) {
      if (container.dataset.qbInit) return;
      container.dataset.qbInit = '1';
     // 基础价为 0 时不显示批量价和询价按钮
  var base = parseInt(container.dataset.basePrice, 10) || 0;
  if (base === 0) {
    container.style.display = 'none';
    var form = container.closest('form');
    if (form) {
      var quoteBtn = form.querySelector('.wholesale-quote-button');
      if (quoteBtn) quoteBtn.style.display = 'none';
    }
    return;
  }
      buildList(container);

      var teaser = container.querySelector('[data-qty-breaks-teaser]');
      var panel = container.querySelector('[data-qty-breaks-panel]');
      var toggle = container.querySelector('[data-qty-breaks-toggle]');

      // 点击 Request Bulk Quote 后展开完整批量价面板
      if (toggle && panel && teaser) {
        toggle.addEventListener('click', function () {
          teaser.hidden = true;
          teaser.style.display = 'none';   // 强制隐藏
          panel.hidden = false;
          panel.style.display = 'block';   // 强制显示
          update(container);
        });
        
      } else if (panel) {
        // 如果没有 teaser（旧结构兜底），默认展开
        panel.hidden = false;
        update(container);
      }

      var form = container.closest('form');
      var input = form ? form.querySelector('[data-quantity-input]') : null;
      if (input) {
        input.addEventListener('input', function () { update(container); });
        input.addEventListener('change', function () { update(container); });
      }

      var list = container.querySelector('[data-qty-breaks-list]');
      if (list && input) {
        list.addEventListener('click', function (e) {
          var item = e.target.closest('.qty-breaks__item');
          if (!item) return;
          var min = parseInt(item.dataset.qbMin, 10);
          input.value = min;
          input.dispatchEvent(new Event('input', { bubbles: true }));
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }
    }
  
    function scan() {
      var nodes = document.querySelectorAll('[data-qty-breaks]');
      for (var i = 0; i < nodes.length; i++) initContainer(nodes[i]);
    }
  
    if (!window.__qbVariantBound) {
      window.__qbVariantBound = true;
      document.addEventListener('variant-change', function (e) {
        var form = e.target && e.target.closest ? e.target.closest('form') : null;
        var container = form ? form.querySelector('[data-qty-breaks]') : null;
        if (!container) { scan(); return; }
  
        var variant = (e.detail && e.detail.variant) ? e.detail.variant : null;
        if (variant) {
          if (variant.price != null) {
            container.dataset.basePrice = toCents(variant.price);
          }
          if (variant.id != null) {
            container.dataset.variantId = variant.id;
          }
        }
  
        buildList(container);
        update(container);
      },true);
    }
  
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', scan);
    } else {
      scan();
    }
  
    if (window.MutationObserver) {
      var mo = new MutationObserver(function (mutations) {
        var found = false;
        mutations.forEach(function (mu) {
          mu.addedNodes.forEach(function (n) {
            if (n.nodeType === 1 &&
              ((n.matches && n.matches('[data-qty-breaks]')) ||
               (n.querySelector && n.querySelector('[data-qty-breaks]')))) {
              found = true;
            }
          });
        });
        if (found) scan();
      });
      mo.observe(document.body, { childList: true, subtree: true });
    }
  
  })();
